













import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import LimpezaConsultor from "../components/LimpezaConsultor.vue";
import LimpezaEstoque from "../components/LimpezaEstoque.vue";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
    LimpezaConsultor,
    LimpezaEstoque,
  },
})
export default class TabLimpezaBase extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
}
